import { useGetGuide, type GuideInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { removeHtmlTags } from "@/utils";
import { Box, Center, Flex, Grid, Spinner, Text } from "@chakra-ui/react";
import { CustomDescription, CustomTitle } from "./guideDetail.style";

export const GuideDetail = () => {
    const { data } = useGetGuide<GuideInfoResponse>({ section: "guide" });
    const currentGuide = data?.currentGuide[0].contents.split("●");
    currentGuide?.shift();

    const { isMobile, isTablet } = MEDIA();

    return data ? (
        <Center as="section" flexDir="column" rowGap={isTablet ? "32px" : "64px"}>
            <Center flexDir="column">
                <CustomTitle fontFamily="Cormorant">Pension Notice</CustomTitle>
                <Text fontFamily="Cormorant">예약 상세안내</Text>
            </Center>
            <Grid gridTemplateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(2, 1fr)"} gridGap="40px">
                {currentGuide &&
                    currentGuide?.map((current) => {
                        const contentGroup = current.split("<br><br>");

                        const title = contentGroup[0];
                        const isBr = /<br>/.test(contentGroup[1]);
                        const isDot = /ㆍ/.test(contentGroup[1]);
                        const contents = contentGroup[1]?.split("<br>");
                        const dotContents = isDot ? contentGroup[1]?.split("ㆍ") : contentGroup[1]?.split("-");

                        return (
                            <Flex flexDir="column" rowGap="16px" key={`${current}_${Math.random()}`}>
                                <CustomDescription.TITLE>
                                    ● {removeHtmlTags(title, "").cleanText}
                                </CustomDescription.TITLE>
                                <Box>
                                    {isBr
                                        ? contents.map((content) => {
                                              const isDiv = /<div>/.test(content);
                                              const { cleanText } = removeHtmlTags(content, "");
                                              const isArrayText = Array.isArray(cleanText);
                                              const newContents = isDiv && !isArrayText && cleanText.split("ㆍ");

                                              return (
                                                  <CustomDescription.SUB key={`${content}_${Math.random()}`}>
                                                      {newContents
                                                          ? newContents.map((newContent, idx) => {
                                                                return (
                                                                    idx > 0 && (
                                                                        <CustomDescription.SUB>
                                                                            {`ㆍ${newContent}`}
                                                                        </CustomDescription.SUB>
                                                                    )
                                                                );
                                                            })
                                                          : cleanText}
                                                  </CustomDescription.SUB>
                                              );
                                          })
                                        : dotContents.map((dotContent, idx) => {
                                              const { cleanText } = removeHtmlTags(dotContent, "");

                                              return (
                                                  <CustomDescription.SUB key={`${dotContent}_${Math.random()}`}>
                                                      {idx > 0 && `${isDot ? "ㆍ" : "-"} ${cleanText}`}
                                                  </CustomDescription.SUB>
                                              );
                                          })}
                                </Box>
                            </Flex>
                        );
                    })}
            </Grid>
        </Center>
    ) : (
        <Spinner />
    );
};
